import React, { useState, useEffect } from "react";

// Components imports
import Button from "../Button/Button";

// Scss imports
import css from "./Pagination.module.scss";

// redux
import { useDispatch } from "react-redux";
import {
  getAllPagePapers,
  getCertainPagePapers,
  getNotArchivedPagePapers
} from "../../../redux/actions/papersActions";

import {
  getArchiveOfCurrentUser,
  getArchiveOfCurrentUserForCurrentYear
} from "../../../redux/actions/archiveActions";

import {
  getAllUsers,
  getCertainUser,
  getCountAllUsers
} from "../../../redux/actions/allUsers";

interface PaginationProps {
  text?: string;
  pagesNumber: number;
  papers?: string;
  activePage: number;
  setActivePage: Function;
  allPagePapers?: any;
  certainPagePapers?: any;
  pageLimit: number;
  query?: any;
}

const Pagination: React.FC<PaginationProps> = ({
  pagesNumber,
  papers,
  activePage,
  setActivePage,
  allPagePapers,
  certainPagePapers,
  pageLimit,
  query
}) => {
  const dispatch = useDispatch();

  // Pages for creating pagination numbers deepends on pages numbers

  useEffect(() => {
    if (papers === "all") {
      dispatch(getAllPagePapers(activePage, pageLimit, query));
    } else if (papers === "lastYear") {
      dispatch(getCertainPagePapers(activePage, pageLimit, query));
    } else if (papers === "notArchived") {
      dispatch(getNotArchivedPagePapers(activePage, pageLimit));
      //dispatch(getNotArchivedPagePapers());
    } else if (papers === "archive") {
      dispatch(getArchiveOfCurrentUser(activePage, pageLimit, query));
    } else if (papers === "archiveLastYear") {
      dispatch(
        getArchiveOfCurrentUserForCurrentYear(activePage, pageLimit, query)
      );
    } else if (papers === "allUsers") {
      dispatch(getAllUsers(activePage, pageLimit, ""));
    }
  }, [activePage]);

  const createPaginationNumbers = () => {
    const pagesArray: any = [];
    for (let i: number = 1; i <= pagesNumber; i++) {
      pagesArray.push(i);
    }

    return pagesArray.map((page) => {
      return (
        <div className={css.buttonContainer}>
          {" "}
          <Button
            text={page}
            onButtonClickHandler={(e) => {
              setActivePage(e.target.innerText);
            }}
            type="paginationButton"
          />
        </div>
      );
    });
  };
  return <div className={css.container}>{createPaginationNumbers()}</div>;
};

export default Pagination;
